module.exports = __webpack_public_path__ + "static/media/vaseDefault.6250b0a3.png";